module.exports = __webpack_public_path__ + "images/category_lp/watch_samples/sec02_3_pc_fb704eb40f47630ad4c2f8937b450ac4.jpg";